export default async function HolidayPromoSetup() {
  const holidayBanner = document.querySelector("a.holiday-banner")
  if (!holidayBanner) return

  if (!window.ReactRailsUJS) {
    const ReactRailsUJS = await import("./react_ujs")
    const HolidayModal = await import("app/components/upgrade_plan_modal/holiday_modal")
    const { initSentryReact } = await import("app/scripts/sentry_react_setup")

    initSentryReact()

    window.App.Comps = window.App.Comps || {}
    window.App.Comps["HolidayModal"] = HolidayModal.default

    ReactRailsUJS.default.mountComponents()
  }

  holidayBanner.addEventListener("click", ev => {
    ev.preventDefault()

    window.App.Utils?.logCustomDatadogAction?.("holiday_banner_click")

    if (!window.ReactRailsUJS) {
      window.App.Utils?.logCustomDatadogAction?.("holiday_checkout_redirect")
      window.location.href = holidayBanner.getAttribute("href")
    }
  })
}
